import PropTypes from 'prop-types';
import React from 'react';

import {
  Modal,
} from '@salesforce/design-system-react';

function useToggle(initialValue = false) {
  const [value, setValue] = React.useState(initialValue);
  const toggle = React.useCallback(() => {
    setValue((v) => !v);
  }, []);
  return [value, toggle];
}

function useToggle2(initialValue = false) {
  const [value, setValue] = React.useState(initialValue);
  const toggle = React.useCallback(() => {
    setValue((v) => !v);
  }, []);
  return [value, toggle];
}

const MilestoneInstructions = (props) => {
  const [isOpen, toggleIsOpen] = useToggle();
  const [isOpen2, toggleIsOpen2] = useToggle2();

  const endContent = (
    <div>
      Welcome to the journey builder! At this stage of the Hero process, we
      start to flesh out your story by identifying 5 key milestones that capture
      important interactions between your customer and our Hero. We start by
      defining the beginning and the end of your story, or the Trigger and
      Triumph milestones, because once we know the beginning and end, the middle
      gets a lot easier to fill in!
      <br />
      Don't get concerned that we're selecting a single event for these
      milestones. In a later stage, we'll add additional story elements that
      will connect each milestone together. Follow the instructions below for
      using the tools and make sure to check out the Q-Tips provided by Astro!
    </div>
  );
  const middleConent = (
    <div>
      Don't you feel better knowing how the story will begin and end? Now we
      need to capture the Key, Guide and Crisis milestones to flesh out the
      remainder of our story. Remember, don't get worried about having to select
      a single event for each of these milestones. In the next stage, we'll add
      additional story elements that will connect each milestone together.
      <br />
      Follow the instructions below for using the tools and make sure to check
      out the Q-Tips provided by Astro!
    </div>
  );

  const getMilestoneDescription = (milestone) => {
    switch (milestone) {
      case 'trigger':
        return [
          'The Trigger milestone represents the single event that causes your Hero to set off on this journey. Discuss potential Trigger events with your team and use the tool below to capture each idea. After a few minutes, decide which would be the best Trigger milestone, then use the drop down to select it.',
          <br />,
          <br />,
          "Make sure to consider your business challenge - our trigger should be setting us up to solve for this throughout our story. Also, consider your audience and the personas you've selected - which potential trigger event will resonate best?",
        ];
      case 'triumph':
        return [
          "The Triumph milestone represents the end of your Hero's journey. This event should encapsulate all of the success and transformation of your hero on their journey. Discuss potential Triumph events with your team and use the tool below to capture each idea. After a few minutes, decide which would be the best Triumph milestone, then use the drop down to select it.",
          <br />,
          <br />,
          "Make sure to consider your business challenge - your Triumph should be putting a pretty bow on top of a story that clearly demonstrates how we've solved for your business challenge.",
        ];
      case 'guide':
        return [
          "The Guide milestone represents the event that guides our hero to your customer's solution. The Guide milestone often becomes the marketing arc of our story with targeted ads and curated marketing journeys, but don't let marketing silo your conversation. Discuss potential Guide events with your team and use the tool below to capture each idea. After a few minutes, decide which would be the best Guide milestone, then use the drop down to select it.",
          <br />,
          <br />,
          'Make sure to consider your business challenge - your guide milestone often marks the first direct interaction that your Hero has with your customer. First impressions matter, especially when improving customer experience.',
        ];
      case 'key':
        return [
          "The Key milestone represents the point when your Hero adopts your customer's solution. If this were a standard sales story, you can think of this milestone as the point of sale. Discuss potential Key events with your team and use the tool below to capture each idea. After a few minutes, decide which would be the best Key milestone, then use the drop down to select it.",
          <br />,
          <br />,
          'Make sure to consider your business challenge - your key milestone often marks the first direct interaction that your Hero has with your customer. Impressions matter, especially when improving customer experience. How can you make this one memorable?',
        ];
      case 'crisis':
        return [
          "We wouldn't have a very compelling story if your customer doesn't have a chance to save the day, right? The Crisis milestone represents hardship that your Hero experiences during their journey. This shouldn't be at the fault of either your Hero or your customer, but it should showcase how in your customer's future state, they make simple work of this problem. Discuss potential Crisis events with your team and use the tool below to capture each idea. After a few minutes, decide which would be the best Crisis milestone, then use drop down to select it.",
          <br />,
          <br />,
          'Make sure to consider your business challenge - your Guide milestone often marks the first direct interaction that your Hero has with your customer. Impressions matter, especially when improving customer experience.',
        ];
      default:
        return ['No Content'];
    }
  };

  return (
    <React.Fragment>
      <div 
        style={{ fontSize: '.8rem'}}>
          What is the <span style={{ color: '#1B96FF', fontWeight: '600', cursor: 'pointer'}} onClick={toggleIsOpen}>{props.displayMilestone}?</span>
      </div>
      <Modal
        isOpen={isOpen}
        onRequestClose={toggleIsOpen}
        heading="What are Milestones?"
      >
        <div
          style={{
            marginTop: '5px',
            marginBottom: '5px',
          }}
          className="slds-text-body_large slds-p-around_medium"
        >
          <p> {getMilestoneDescription(props.milestone)}</p>
        </div>
      </Modal>
    </React.Fragment>
  );
};

MilestoneInstructions.propTypes = {
  milestone: PropTypes.string.isRequired,
};

export default MilestoneInstructions;
